import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import { LocalTranslations, LocalAssets } from '../../requests/apa/local';
import translatesJson from './AAFModalError.translates.json';
import assetsJson from './AAFModalError.assets.json';
import PropTypes from 'prop-types';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import './styles/AAFModalError.scss';
import logger from 'src/utils/logger/logger';
import { Button } from '../../packages/components';
import { QR_GENERATION_ERROR } from './constants';
import Utils from '../../utils/Utils';
import { GA4 } from '../../utils/trackers/GA4';
import { ALERT_TYPE_L_3_A, ERROR_GENERACION_QR, PANTALLA_GENERACION_QR } from '../../utils/trackers/GA4Constants';

const localTranslations = new LocalTranslations(translatesJson);
const localAssets = new LocalAssets(assetsJson);

const AAFModalError = (props = {}) => {
  const buttonLabelDefault = localTranslations.get('alert_warning_generic_button_close', 'ACEPTAR');
  const contentDefault = localTranslations.get('alert_warning_generic_message_label');
  const defaultTitle = localTranslations.get('ti_modal_retry', '¡Ocurrió algo inesperado!');
  const title = props.title || defaultTitle;
  const { code, message, textButton, colorButton, withBack = true, errorFrom, extendedMessage: {resultCode = '', resultMessage = ''} = {} } = props.content;
  // Dynamic backend error code: keys cannot be statically enumerated, so they stay on the remote Translator/Asset service.
  let content = Translator.get(code, contentDefault);
  if (message && typeof message === 'string') content = Translator.get(message);
  const replaces = props.replaces || null;
  const alertIcon = Asset.get(`${code}_icon`) === `${code}_icon` ? Asset.get('alert_warning_generic_icon'): Asset.get(`${code}_icon`);
  let buttonLabel = Translator.get(`${code}_close`, buttonLabelDefault);
  let styleColorButton = undefined;
  const labelReplace = localTranslations.get('alert_warning_external_message_label', '');
  if (props.session && !code) {
    content = Translator.get(
      'error_404_not_found',
      'Servicio no disponible, intentar más tarde'
    );
  }

   if (errorFrom === "parental-rating-mis_grabaciones") {
      buttonLabel = textButton;
      styleColorButton = colorButton;
  }

  /**
   * validate if display or not additional info
   * @returns label
   */
  const labelDetailMessage = () => {
    if (labelReplace !== '' && (resultCode !== undefined || resultCode !== null || resultCode !== '') && resultMessage) {
      return labelReplace.replace('@resultCode', resultCode).replace('@resultMessage', resultMessage);
    }
    return '';
  }

  const sendMetricsQrGenerationAlert = (title) => {
    const ga4 = new GA4
    const metricsProps = {
      page_path: ERROR_GENERACION_QR,
      page_title: title,
      previous_path: PANTALLA_GENERACION_QR,
      alert_type: ALERT_TYPE_L_3_A,
      modulo_name: title
    }

    ga4.sendMetricsQrGenerationAlert(metricsProps);
  }

  const sendMetricsQrGenerationEventError = (title, statusCode, message) => {
    const ga4 = new GA4
    const metricsProps = {
      page_path: ERROR_GENERACION_QR,
      page_title: title,
      previous_path: PANTALLA_GENERACION_QR,
      error_code: statusCode,
      error_message: message
    }

    ga4.sendMetricsQrGenerationEventError(metricsProps);
  }

  const sendMetricsQrGenerationErrorInteraction = (title, button) => {
    const ga4 = new GA4
    const metricsProps = {
      page_path: ERROR_GENERACION_QR,
      page_title: title,
      previous_path: PANTALLA_GENERACION_QR,
      alert_type: ALERT_TYPE_L_3_A,
      modulo_name: title,
      interaction_type: button,
    }

    ga4.sendMetricsQrGenerationErrorInteraction(metricsProps);
  }

  const renderQRGenerationError = () => {
    const statusCode = props && props.error && props.error.status ? props.error.status : null

    const title = Translator.get('alerta_falloconexionqr_titulo_texto')
    const description = Translator.get('alerta_falloconexionqr_parrafo_texto')
    const button = Translator.get('alerta_falloconexionqr_boton_texto_reintentar')
    const code = Translator.get('alerta_falloconexionqr_parrafo_texto_codigoerror')
    const codeWithStatus = code.replace('@code', statusCode)

    // Envía las métricas de la alerta
    sendMetricsQrGenerationAlert(title)
    // Agregar tratamiento para quitar tildes y mayusculas
    sendMetricsQrGenerationEventError(title, statusCode, description)

    const buttonHandler = (e) => {
      if (props && props.isFromOtherModal) {
        if (props.otherModalCallback && typeof props.otherModalCallback === 'function') {
          props.otherModalCallback()
        }
      } else {
        props.handleClose(e, props.callback);
      }
      // Envía las métricas del botón
      sendMetricsQrGenerationErrorInteraction(title, button)
    }

    return (
      <div className='aaf-qr-generation-error'>
        <div className='aaf-qr-generation-error__title'>
          { Utils.cutPlayerString(title, 32) }
        </div>
        <div className='aaf-qr-generation-error__description'>
          { Utils.cutPlayerString(description, 128) }
        </div>
        <Button
          id="aaf-qr-generation-error-button"
          type="button"
          variant={null}
          className="aaf-qr-generation-error__button focusable"
          onClick={(e) => {
            buttonHandler(e)
          }}
        >
          { Utils.cutPlayerString(button, 22) }
        </Button>
        <div className='aaf-qr-generation-error__code'>
          { Utils.cutPlayerString(codeWithStatus, 20) }
        </div>
      </div>
    )
  }

  if (typeof props.setMetricsEvent === 'function') {
    const sendDimension = () => {
      const payload = new AnalyticsDimensionSingleton().getPayload();
      props.setMetricsEvent(payload);
      props.setMetricsEvent({ type: 'executor' });
    };
    const sendMetric = () => {
      props.setMetricsEvent({
        hitType: 'event',
        eventCategory: 'errores',
        eventAction: title,
        eventLabel: content,
      });
      props.setMetricsEvent({ type: 'executor' });
      sendDimension();
    };
    sendMetric();
  }

  const p = {
    showLogo: labelDetailMessage() !== '',
    content,
    replaces,
    children: labelDetailMessage(),
    asset: props.asset ? Asset.get(props.asset) : alertIcon,
    alwaysEnabled: true,
    handleBackKey: props.handleBackKey ? props.handleBackKey : (e) => props.handleClose(e, props.callback),
    /**
     * Always enabled in modal error
     * @returns yellow button
     */
    yellowAction: (e) => props.handleClose(e, props.callback),
    colorButtons: labelDetailMessage() !== '' || !withBack ? [] : [
        {
            content: localTranslations.get('top_head_option_button_back', 'REGRESAR'),
            props: {
                color: 'yellow',
                className: 'modal-button-return',
                imgSrc: localAssets.get('top_head_option_back', ''),
                onClick: (e) => {
                  props.handleClose(e, props.callback);
                },
            },
        },
    ],
    buttons: [
      {
        content: buttonLabel,
        props: {
          onClick: (e) => {
            props.handleClose(e, props.callback);
          },
          className: 'aaf-modal-button aaf-modal-button-primary',
          style: { backgroundColor: styleColorButton }
        },
      },
    ],
    aafNewStyle: true,
    className: 'aaf-modal aaf-modal-error',
  };

  if (props.title) p.title = title;

  switch (props.type) {
    case QR_GENERATION_ERROR:
      const statusCode = props.error && props.error.status
      const isValidStatusCode = statusCode && (statusCode === 400 || statusCode === 429 || statusCode === 500)

      if (!isValidStatusCode) {
        return <ModalWrapper {...p} />
      }

      const qrGenerationErrorProps = {
        children: renderQRGenerationError(),
        handleBackKey: () => {},
      }

      return <ModalWrapper {...qrGenerationErrorProps} />
    default:
      return <ModalWrapper {...p} />
  }
};

AAFModalError.propTypes = {
  asset: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.object,
  callback: PropTypes.func,
  className: PropTypes.string,
};

AAFModalError.defaultProps = {
  content: {
    code: 'modal_msg_error_default',
    message: 'Por favor vuelve a intentarlo',
  },
  callback: () => {
    logger.debug('callback...');
  },
};

export default withOnClose(AAFModalError);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalError.jsx